// extracted by mini-css-extract-plugin
export default {"total":"calculator_total__bDUxh","calculator":"calculator_calculator__NBgiQ","backspace":"calculator_backspace__V5D9K","active":"calculator_active__8+bud"};